import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { StyledNavLink } from './StyledNavLink';
import { IRoute } from '../../interfaces';

interface MenuListItemProps {
  route: IRoute;
}

export const MenuListItem: React.FC<MenuListItemProps> = ({ route }) => {
  return (
    <ListItem
      sx={{
        '&:hover': {
          backgroundColor: 'action.hover',
          cursor: 'pointer',
        },
      }}
      component={StyledNavLink}
      to={route.path}
    >
      <ListItemIcon>
        <route.icon />
      </ListItemIcon>
      <ListItemText>
        <Typography>{route.title}</Typography>
      </ListItemText>
    </ListItem>
  );
};
